import { render, staticRenderFns } from "./CustomTag.vue?vue&type=template&id=050ad18a&scoped=true&"
import script from "./CustomTag.vue?vue&type=script&lang=ts&"
export * from "./CustomTag.vue?vue&type=script&lang=ts&"
import style0 from "./CustomTag.vue?vue&type=style&index=0&id=050ad18a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050ad18a",
  null
  
)

export default component.exports